import { DataHeader, DataSource, Layout, Location, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverEventsList extends Layout {
    dataheaderDriverEventsList: DataHeader;
    panelDriverEventsSearch: Panel;
    searchDriverEvents: SearchPanel;
    sourceDriverEvents: DataSource;
    tableDriverEvents: Table;
    textboxDriverEventLocation: Location;
    textboxDriverMgrId: Textbox;
    textboxEntryDate: Textbox;
    textboxEquipmentId: Textbox;
    textboxEventCode: Textbox;
    textboxEventStatus: Textbox;
    textboxGridEnteredBy: Textbox;
    textboxNotifyStartDate: Textbox;
    textboxStartDate: Textbox;
}
